module.exports = "/_next/static/images/illustration-1b756e41f4558b131c99aa4d8b15f291.png";